import cn from 'classnames';
import type { ReactNode } from 'react';
import { Col } from '../col';
import { Link } from '../link';
import { Row } from '../row';
import type { TagProperties } from '../tag';
import { type CardProgressProperties, DataCardBody } from './data-card-body';
import type { DataCardDescriptionProperties } from './data-card-description';
import type { ParticipantsProperties } from './data-card-participants';
import type { PricesProperties } from './data-card-price';
import { ThumbnailImage } from './thumbnail-image';

type P = {
  className?: string;
  description?: DataCardDescriptionProperties;
  image: { action?: ReactNode; alt?: string; height?: number; meta?: ReactNode; src: string };
  participantsProperties?: ParticipantsProperties;
  path: string;
  pricesProperties?: PricesProperties;
  progressProperties?: CardProgressProperties;
  tag?: TagProperties | TagProperties[];
  title: string;
};

const DataCard = ({
  className,
  description,
  image,
  participantsProperties,
  path,
  pricesProperties,
  progressProperties,
  tag,
  title,
}: P) => (
  <Link className={cn('data-card', className)} effects={{ focus: true }} to={path}>
    <Row>
      <Col className="data-card__cover-photo" span={24}>
        {/* TODO: Image behavior and properties will be fixed along with 16:9 update for the card */}
        <ThumbnailImage
          action={image.action}
          image={{
            alt: image.alt,
            className: 'data-card__cover-photo__image',
            height: image.height ?? 160,
            preview: false,
            src: image.src,
          }}
          meta={image.meta}
        />
      </Col>
      <Col span={24}>
        <DataCardBody
          description={description}
          participantsProperties={participantsProperties}
          pricesProperties={pricesProperties}
          progressProperties={progressProperties}
          tag={tag}
          title={title}
        />
      </Col>
    </Row>
  </Link>
);

export default DataCard;
